import { render, staticRenderFns } from "./EditarPersona.vue?vue&type=template&id=117d41c7"
import script from "./EditarPersona.vue?vue&type=script&lang=js"
export * from "./EditarPersona.vue?vue&type=script&lang=js"
import style0 from "./EditarPersona.vue?vue&type=style&index=0&id=117d41c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports